import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const profCollaboratorSchema = () =>
  yup.object({
    iD_Sector: yup.string().label(i18n2._('#Sector')),
    iD_Profile: yup.string().label(i18n2._('#Perfil')),
    employee_Nr: yup
      .array()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Employee Number')),
    name_Employee: yup.string().label(i18n2._('Colaborador')),
    cwid: yup.string().label(i18n2._('CWID')),
    iD_ProfileSpac: yup
      .array()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('#Perfil Spac')),
    throwInstances: yup.boolean().label(i18n2._('Lanzar instancias')),
    spac: yup.string().label(i18n2._('SPAC')),
    name_Spac: yup.string().label(i18n2._('Nombre del SPAC')),
    name_ProfSpac: yup.string().label(i18n2._('Profile Spac')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
